import { Table } from "../../components/Table";
import { useStyles } from "./styles";
import Stack from "@mui/material/Stack";
import { useQuery } from "react-query";
import {
  listReprocessAudienceOut,
  listReprocessAudienceIn,
} from "../../services/insights";
import { useAudience } from "../../hooks/useAudience";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { Login } from "@mui/icons-material";
import { PaperChart } from "../../components/PaperChart";
import { format, parseISO } from "date-fns";

function MovimentacaoReprocesso() {
  const navigate = useNavigate();
  const context = useAudience();
  const styles = useStyles();
  const reprocesso = context.reprocessoAudiencia;

  const listOut = useQuery(
    ["listReprocessAudienceOut", reprocesso.id_prospeccao_lista],
    async () => {
      const response = await listReprocessAudienceOut(
        reprocesso.id_prospeccao_lista
      );
      return response;
    }
  );

  const listIn = useQuery(
    ["listReprocessAudienceIn", reprocesso.id_prospeccao_lista],
    async () => {
      const response = await listReprocessAudienceIn(
        reprocesso.id_prospeccao_lista
      );
      return response;
    }
  );

  const handleNavigateToDetails = useCallback(
    (item: any) => {
      navigate(`people/${item.id_pessoa}`, { state: item });
    },
    [navigate]
  );

  return (
    <>
      <Stack spacing={4}>
        <PaperChart
          loading={listIn.isLoading}
          label="Pessoas que entraram"
          className={styles.paperCreatedDay}
          variant="outlined"
          elevation={0}
        >
          <Table
            search
            columnsButton
            pageSize={7}
            columns={[
              { title: "#ID", field: "id_pessoa" },
              { title: "Nome", field: "nome" },
              { title: "Documento", field: "documento" },
              {
                title: "Data de nascimento",
                field: "data_nascimento",
                render: (row) =>
                  format(
                    parseISO(row?.data_nascimento?.replace("Z", "")),
                    "dd/MM/yyyy"
                  ),
              },
              { title: "Celular", field: "celular1" },
              { title: "Email", field: "email1" },
              {
                title: "Ações",
                align: "center",
                render: (row) => (
                  <Tooltip title="Ver detalhes" placement="top">
                    <IconButton onClick={() => handleNavigateToDetails(row)}>
                      <Login />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            data={listIn.data as []}
            style={{ backgroundColor: "transparent" }}
            headerStyle={{ backgroundColor: "transparent" }}
          />
        </PaperChart>
        <PaperChart
          loading={listOut.isLoading}
          label="Pessoas que sairam"
          className={styles.paperCreatedDay}
          variant="outlined"
          elevation={0}
        >
          <Table
            search
            columnsButton
            pageSize={7}
            columns={[
              { title: "#ID", field: "id_pessoa" },
              { title: "Nome", field: "nome" },
              { title: "Documento", field: "documento" },
              {
                title: "Data de nascimento",
                field: "data_nascimento",
                render: (row) =>
                  format(
                    parseISO(row?.data_nascimento?.replace("Z", "")),
                    "dd/MM/yyyy"
                  ),
              },
              { title: "Celular", field: "celular1" },
              { title: "Email", field: "email1" },
              {
                title: "Ações",
                align: "center",
                render: (row) => (
                  <Tooltip title="Ver detalhes" placement="top">
                    <IconButton onClick={() => handleNavigateToDetails(row)}>
                      <Login />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            data={listOut.data as []}
            style={{ backgroundColor: "transparent" }}
            headerStyle={{ backgroundColor: "transparent" }}
          />
        </PaperChart>
      </Stack>
    </>
  );
}

export default MovimentacaoReprocesso;
